import { PagoDetalle } from "../../bussines/entities/Pago";

export class PagoDetalleModel implements PagoDetalle {
    constructor(
        public idPago: number,
        public nroLinea: number,
        public codigoBarra: string,
        public descArticulo: string,
        public cantidad: number,
        public codUnidadMedida: string,
        public precioUnitario: number,
        public totalArticulo: number,
    ) {}

    serialize(): PagoDetalle {
        return {
            idPago: this.idPago,
            nroLinea: this.nroLinea,
            codigoBarra: this.codigoBarra,
            descArticulo: this.descArticulo,
            cantidad: this.cantidad,
            codUnidadMedida: this.codUnidadMedida,
            precioUnitario: this.precioUnitario,
            totalArticulo: this.totalArticulo,
        }
    }

    static deserialize(entity: PagoDetalle): PagoDetalleModel {
        return new PagoDetalleModel(
            entity.idPago,
            entity.nroLinea,
            entity.codigoBarra,
            entity.descArticulo,
            entity.cantidad,
            entity.codUnidadMedida,
            entity.precioUnitario,
            entity.totalArticulo,
        )
    }
}